export const ConstantStrings = {
    // Ethical Channel url
    externalUrl:{
        ethicalChannel: 'https://artisdevelopment.canales-eticos.com', 
        linkedin: 'https://www.linkedin.com/company/artisdevelopment',
        transparencyPortal: "https://artisdevelopment.canariastransparente.org" 
    },
    // Markdown files
    markdownFiles: {
        privacyPolicy: 'privacyPolicy',
        dataProtectionPolicy: 'dataProtectionPolicy',
        cookiePolicy: 'cookiePolicy',
        qualityPolicy: 'qualityPolicy',
        informationSecurityPolicy: 'informationSecurityPolicy',
        informationSecurityPolicyENS: 'informationSecurityPolicyENS',
        transparencyPortal: 'transparencyPortal',
    },
    // Referenes
    externalRefereces: {
        1: 'https://doi.org/10.1016/J.CLNU.2018.08.002',
        2: 'https://doi.org/10.20960/nh.03638',
        3: 'https://doi.org/10.1016/j.clnu.2018.09.026',
        4: 'https://doi.org/10.1093/ageing/afy169'
    }   
}